import { useStore } from "ra-core";

/** Persisted per browser; the sidebar starts collapsed to icons. */
export const useSidebarExpanded = () =>
  useStore<boolean>("sidebar.expanded", false);
